import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, Sparkles, Star, Shield, Clock } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-6 pb-16 md:pt-10 md:pb-24 overflow-hidden bg-gradient-to-b from-[#FDFBF7] to-white" data-id="element-328">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, #2D5016 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-329"></div>

      <div className="container mx-auto px-4 max-w-6xl relative" data-id="element-330">
        {/* Trust bar above headline */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex justify-center mb-6" data-id="element-331">
          <div className="flex items-center gap-4 bg-white border border-[#D4AF37]/30 rounded-full px-5 py-2 shadow-sm flex-wrap justify-center gap-y-1" data-id="element-332">
            <div className="flex items-center gap-1.5" data-id="element-333">
              <div className="flex" data-id="element-334">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3.5 h-3.5 fill-[#D4AF37] text-[#D4AF37]" data-id="element-335" />)}
              </div>
              <span className="text-xs font-bold text-gray-700" data-id="element-336">4.9/5</span>
            </div>
            <span className="w-px h-4 bg-gray-200" data-id="element-337"></span>
            <span className="text-xs font-semibold text-gray-600" data-id="element-338">
              +10,000 clientas satisfechas
            </span>
            <span className="w-px h-4 bg-gray-200" data-id="element-339"></span>
            <span className="text-xs font-semibold text-green-700 flex items-center gap-1" data-id="element-340">
              <Shield className="w-3 h-3" data-id="element-341" /> Garantía 90 días
            </span>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-342">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="order-2 md:order-1" data-id="element-343">
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-700 px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider mb-5 border border-red-100" data-id="element-344">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-345"></span>
              🔥 Últimas Unidades — Oferta Termina Hoy
            </div>

            <h1 className="md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-5 text-[40px]" data-id="element-346">
              Hasta 8 kg menos en 21 días — sin inyecciones, dietas estrictas ni
              pastillas.
            </h1>

            <p className="text-xl text-gray-700 mb-2 font-semibold leading-snug" data-id="element-347">
              StingFit™ activa el drenaje linfático y ayuda a quemar grasa
              abdominal incluso mientras duermes.
            </p>

            <p className="text-base text-gray-500 mb-7 leading-relaxed" data-id="element-348">
              Tecnología transdérmica de última generación. Un parche al día.
              Resultados visibles en 7 días o te devolvemos el dinero.
            </p>

            <div className="space-y-2.5 mb-8" data-id="element-349">
              {[{
              text: 'Hasta 8 kg en 21 días — resultados reales verificados',
              hot: true
            }, {
              text: 'Activa el metabolismo y quema grasa localizada',
              hot: false
            }, {
              text: 'Reduce la hinchazón abdominal visible desde el día 1',
              hot: false
            }, {
              text: 'Drenaje linfático natural mientras duermes',
              hot: false
            }, {
              text: 'Sin pastillas · 100% tópico · Un parche al día',
              hot: false
            }].map((benefit, i) => <div key={i} className={`flex items-center gap-3 ${benefit.hot ? 'bg-[#D4AF37]/10 -mx-3 px-3 py-2 rounded-xl' : ''}`} data-id="element-350">
                  <CheckCircle2 className={`w-5 h-5 flex-shrink-0 ${benefit.hot ? 'text-[#D4AF37]' : 'text-[#2D5016]'}`} data-id="element-351" />
                  <span className={`text-sm font-medium ${benefit.hot ? 'text-gray-900 font-bold' : 'text-gray-700'}`} data-id="element-352">
                    {benefit.text}
                  </span>
                  {benefit.hot && <span className="ml-auto text-xs bg-[#D4AF37] text-white px-2 py-0.5 rounded-full font-bold" data-id="element-353">
                      ⭐ TOP
                    </span>}
                </div>)}
            </div>

            <div className="flex flex-col gap-3" data-id="element-354">
              <Button size="xl" className="w-full group relative overflow-hidden shadow-2xl hover:shadow-[#D4AF37]/40 transition-all duration-300 hover:-translate-y-1" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-355">
                <span className="relative z-10 flex items-center justify-center font-black tracking-wide" data-id="element-356">
                  SI, QUIERO RECUPERAR MI FIGURA
                </span>
              </Button>
              <p className="text-xs text-center text-green-700 font-bold mt-1" data-id="element-357">
                💰 Pago contra entrega en la puerta de tu casa
              </p>

              <div className="flex items-center justify-center gap-4 text-xs font-semibold text-gray-500 flex-wrap" data-id="element-358">
                <span className="flex items-center gap-1" data-id="element-359">
                  <CheckCircle2 className="w-3.5 h-3.5 text-green-600" data-id="element-360" /> Envío
                  Gratis Hoy
                </span>
                <span className="flex items-center gap-1" data-id="element-361">
                  <CheckCircle2 className="w-3.5 h-3.5 text-green-600" data-id="element-362" />{' '}
                  Garantía 90 Días
                </span>
                <span className="flex items-center gap-1" data-id="element-363">
                  <CheckCircle2 className="w-3.5 h-3.5 text-green-600" data-id="element-364" /> Pago
                  100% Seguro
                </span>
              </div>

              {/* Social proof avatars */}
              <div className="flex items-center justify-center gap-3 mt-1 bg-green-50 rounded-2xl py-3 px-4 border border-green-100" data-id="element-365">
                <div className="flex -space-x-2" data-id="element-366">
                  {[32, 45, 67, 78].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-367">
                      <img src={`https://randomuser.me/api/portraits/women/${i}.jpg`} alt="User" data-id="element-368" />
                    </div>)}
                </div>
                <div className="text-left" data-id="element-369">
                  <p className="font-black text-gray-900 text-sm" data-id="element-370">
                    +10,000 mujeres
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-371">
                    ya han transformado su cuerpo este mes
                  </p>
                </div>
                <div className="ml-auto text-right hidden sm:block" data-id="element-372">
                  <p className="text-xs font-bold text-green-700" data-id="element-373">
                    94% ven resultados
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-374">en menos de 14 días</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 md:order-2 relative" data-id="element-375">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-4 ring-[#D4AF37]/20" data-id="element-376">
              <img src="https://cdn.magicpatterns.com/uploads/dFPBUFJSxve5eZXCiqp6GP/imgi_10_1754196580-Copy_of_BeeBalm_–_lindrar_ledvark,_ischias,_artrit_och_halsporre_pa_bara_15_minuter_(4).png" alt="StingFit - Parche de veneno de abeja para drenaje linfático" className="w-full h-full object-contain bg-white" data-id="element-377" />
              {/* Overlay badge */}
              <div className="absolute top-4 right-4 bg-red-600 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg uppercase tracking-wide" data-id="element-378">
                Stock Limitado
              </div>
            </div>

            {/* Floating testimonial badge */}
            <motion.div animate={{
            y: [0, -6, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-2xl max-w-[220px] border-2 border-[#D4AF37]" data-id="element-379">
              <div className="flex items-center gap-2 mb-1" data-id="element-380">
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse" data-id="element-381"></div>
                <span className="text-xs font-black text-green-700 uppercase" data-id="element-382">
                  Verificado
                </span>
              </div>
              <div className="flex mb-1" data-id="element-383">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 fill-[#D4AF37] text-[#D4AF37]" data-id="element-384" />)}
              </div>
              <p className="text-sm font-bold text-gray-900 leading-snug" data-id="element-385">
                "Perdí 6 kg y 8 cm de cintura en 3 semanas."
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-386">— Carmen M., 42 años</p>
            </motion.div>

            {/* Second floating badge */}
            <motion.div animate={{
            y: [0, 5, 0]
          }} transition={{
            duration: 3.5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute -top-4 -right-4 bg-[#2D5016] text-white rounded-2xl p-3 shadow-xl" data-id="element-387">
              <p className="text-2xl font-black text-[#D4AF37]" data-id="element-388">-8 kg</p>
              <p className="text-xs text-green-200" data-id="element-389">media en 21 días</p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}